import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/KWRI/real-react/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "flex-utilities"
    }}>{`Flex Utilities`}</h1>
    <p>{`The flex utilities included with the KW UI Kit directly align with `}<a parentName="p" {...{
        "href": "https://getbootstrap.com/docs/4.1/utilities/flex/"
      }}>{`Bootstrap's Flex Utilities`}</a>{`.`}</p>
    <p>{`These utilities allow you to easily and responsively manage the layout, alignment of flex elements.`}</p>
    <p>{`The container must have `}<inlineCode parentName="p">{`display: flex`}</inlineCode>{` or `}<inlineCode parentName="p">{`display: inline-flex`}</inlineCode>{`. This can be achieved with the display utilities. See the `}<a parentName="p" {...{
        "href": "/docs/display"
      }}>{`display utilities`}</a>{` for more details.`}</p>
    <h3 {...{
      "id": "flex-direction"
    }}>{`Flex Direction`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`direction`}</inlineCode>{` utilities to set the direction of the flex items`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-row`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-row-reverse`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-column`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-column-reverse`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-sm-row`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-sm-row-reverse`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-sm-column`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-sm-column-reverse`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-md-row`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-md-row-reverse`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-md-column`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-md-column-reverse`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-lg-row`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-lg-row-reverse`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-lg-column`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-lg-column-reverse`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "justify-content"
    }}>{`Justify Content`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`justify-content`}</inlineCode>{` utilities on flexbox containers to change the alignment of flex items on the main axis`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-start`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-end`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-center`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-between`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-around`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-sm-start`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-sm-end`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-sm-center`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-sm-between`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-sm-around`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-md-start`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-md-end`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-md-center`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-md-between`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-md-around`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-lg-start`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-lg-end`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-lg-center`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-lg-between`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.justify-content-lg-around`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "align-items"
    }}>{`Align Items`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`align-items`}</inlineCode>{` utilities on flexbox containers to change the alignment of flex items on the cross axis`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-start`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-end`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-center`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-baseline`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-stretch`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-sm-start`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-sm-end`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-sm-center`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-sm-baseline`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-sm-stretch`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-md-start`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-md-end`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-md-center`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-md-baseline`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-md-stretch`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-lg-start`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-lg-end`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-lg-center`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-lg-baseline`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-items-lg-stretch`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "align-self"
    }}>{`Align Self`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`align-self`}</inlineCode>{` utilities on flexbox items to individual change their alignnment on the cross axis`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-start`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-end`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-center`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-baseline`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-stretch`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-sm-start`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-sm-end`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-sm-center`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-sm-baseline`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-sm-stretch`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-md-start`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-md-end`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-md-center`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-md-baseline`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-md-stretch`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-lg-start`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-lg-end`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-lg-center`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-lg-baseline`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.align-self-lg-stretch`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "fill"
    }}>{`Fill`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`flex-fill`}</inlineCode>{` utilities on a series of sibling, flex elements to force them into equal widths when taking up horizontal space`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-fill`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-sm-fill`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-md-fill`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-lg-fill`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "grow-and-shrink"
    }}>{`Grow and Shrink`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`flex-grow-*`}</inlineCode>{` and `}<inlineCode parentName="p">{`flex-shrink-*`}</inlineCode>{` utilities to toggle the flex elements ability to grow and shrink into available respectively.`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-{grow|shrink}-0`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-{grow|shrink}-1`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-sm-{grow|shrink}-0`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-sm-{grow|shrink}-1`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-md-{grow|shrink}-0`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-md-{grow|shrink}-0`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-lg-{grow|shrink}-1`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-lg-{grow|shrink}-1`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "wrap"
    }}>{`Wrap`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`flex-wrap`}</inlineCode>{` utilities to change how flex items wrap in a container`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-nowrap`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-wrap`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-wrap-reverse`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-sm-nowrap`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-sm-wrap`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-sm-wrap-reverse`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-md-nowrap`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-md-wrap`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-md-wrap-reverse`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-lg-nowrap`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-lg-wrap`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.flex-lg-wrap-reverse`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "order"
    }}>{`Order`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`order`}</inlineCode>{` utilities to adjust the order of flex items`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`.order-1`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-2`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-3`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-4`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-5`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-6`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-7`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-8`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-9`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-10`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-11`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-12`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-sm-1`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-sm-2`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-sm-3`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-sm-4`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-sm-5`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-sm-6`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-sm-7`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-sm-8`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-sm-9`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-sm-10`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-sm-11`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-sm-12`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-md-1`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-md-2`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-md-3`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-md-4`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-md-5`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-md-6`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-md-7`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-md-8`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-md-9`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-md-10`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-md-11`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-md-12`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-lg-1`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-lg-2`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-lg-3`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-lg-4`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-lg-5`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-lg-6`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-lg-7`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-lg-8`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-lg-9`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-lg-10`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-lg-11`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.order-lg-12`}</inlineCode></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      